import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
import React from "react";
var __jsx = React.createElement;
const BackArrowMobileIcon = _ref => {
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M4.32959 11.4882L7.77141 14.9257C8.04133 15.1953 8.47896 15.1953 8.74888 14.9257C9.0188 14.6562 9.0188 14.2191 8.74888 13.9495L6.47728 11.6876L17.2089 11.6876C17.589 11.6876 17.8972 11.3798 17.8972 11.0001C17.8972 10.6204 17.589 10.3126 17.2089 10.3126L6.47728 10.3126L8.74888 8.05074C8.8792 7.92165 8.9525 7.74593 8.9525 7.56262C8.9525 7.3793 8.8792 7.20358 8.74888 7.07449C8.61963 6.94434 8.44369 6.87113 8.26014 6.87113C8.0766 6.87113 7.90066 6.94434 7.77141 7.07449L4.32959 10.512C4.19928 10.6411 4.12598 10.8168 4.12598 11.0001C4.12598 11.1834 4.19928 11.3592 4.32959 11.4882Z",
    fill: color
  }));
};
export default BackArrowMobileIcon;